import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { langEn } from './en';
import { langEs } from './es';

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    fallbackLng: 'en',
    resources: {
      en: {
        translation: langEn
      },
      es: {
        translation: langEs
      }
    }
  });

export default i18next;

export const SUPPORTED_LANGUAGES = ['en_US', 'en', 'es_ES', 'es'];
export const ACCEPTED_LOCALES = ['en-US', 'es-ES']; // For Intl formatting
